export const CheckSuccessfulIcon = ({
  className,
  onClick = () => {},
}: { className?: string; onClick?: () => void }) => {
  return <img onClick={onClick} className={`${className}`} src="/assets/check-successful.svg" alt="check icon" />;
};
